/* ══════════════════════════════════════════════════════════════
   World Live TV — Global News Broadcast Grid
   Bloomberg, Al Jazeera, ABC News, Sky News, France 24, DW News
   ══════════════════════════════════════════════════════════════ */

interface WorldChannel {
    name: string;
    youtubeId: string;
    tag: string;
}

const WORLD_CHANNELS: WorldChannel[] = [
    { name: 'Bloomberg TV', youtubeId: 'UCIALMKvObZNtJ6AmdCLP7Lg', tag: 'FINANCE' },
    { name: 'Al Jazeera', youtubeId: 'UCNye-wNBqNL5ZzHSJj3l8Bg', tag: 'WORLD' },
    { name: 'ABC News', youtubeId: 'UCBi2mrWuNuyYy4gbM6fU18Q', tag: 'US' },
    { name: 'Sky News', youtubeId: 'UCoMdktPbSTixAyNGwb-UYkQ', tag: 'UK' },
    { name: 'France 24', youtubeId: 'UCQfwfsi5VrQ8yKZ-UWmAEFg', tag: 'EU' },
    { name: 'DW News', youtubeId: 'UCknLrEdhRCp1aegoMqRaCZg', tag: 'EU' },
];

let expandedChannel: number | null = null;

export function renderWorldLiveTV(container: HTMLElement): void {
    const grid = WORLD_CHANNELS.map((ch, i) => {
        const isExpanded = expandedChannel === i;
        return `
      <div class="wm-tv-item ${isExpanded ? 'wm-tv-item--expanded' : ''}" id="wm-tv-${i}">
        <iframe
          src="https://www.youtube.com/embed/live_stream?channel=${ch.youtubeId}&autoplay=0&mute=1"
          allow="accelerometer; autoplay; encrypted-media; gyroscope"
          allowfullscreen
          loading="lazy"
          title="${ch.name} Live Stream"
        ></iframe>
        <div class="wm-tv-item__label">
          <span>${ch.tag}</span> ${ch.name}
          <button class="wm-tv-expand-btn" data-idx="${i}" style="float:right;background:none;border:none;color:var(--wm-green);cursor:pointer;font-size:10px;">
            ${isExpanded ? '⊟' : '⊞'}
          </button>
        </div>
      </div>
    `;
    }).join('');

    container.innerHTML = `<div class="wm-tv-grid">${grid}</div>`;

    // Expand/collapse
    container.querySelectorAll('.wm-tv-expand-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.stopPropagation();
            const idx = parseInt((btn as HTMLElement).dataset.idx || '0');
            expandedChannel = expandedChannel === idx ? null : idx;
            renderWorldLiveTV(container);
        });
    });
}
